var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-row',{staticClass:"mb-1 mx-2",attrs:{"no-gutters":"","justify":"space-around","align":"center"}},[_c('div',[_vm._t("default")],2),_c('v-spacer'),_c('div',[_vm._t("action")],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }